import { css } from 'aphrodite';
import { styleSheet } from './styles';

export type CountBadgeProps = AphroditeStyled<React.ComponentProps<'span'>> & {
	count: number;
	max?: number;
};

export function CountBadge({ count, max = 9, styles = [], ...props }: CountBadgeProps) {
	if (count <= 0) {
		return null;
	}
	return (
		<span data-slot='count-badge' className={css(styleSheet.root, ...styles)} {...props}>
			{count > max ? `${max}+` : count}
		</span>
	);
}
